import { defineComponent as _defineComponent } from 'vue'
import { createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, unref as _unref, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-bd881bce"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h5", null, "Get the app, and follow the instructions. It's easy!", -1))
const _hoisted_2 = { class: "more-info" }

import { useRouter } from 'vue-router'
import { usePageTitle } from '@webapp/util/AppUtil'
import TaskPage from '@webapp/util/TaskPage.vue'
import SyncAppTile from './SyncAppTile.vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'SyncAppPage',
  setup(__props) {

const router = useRouter()

usePageTitle('Upload my tree')

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createBlock(TaskPage, {
    "no-brand": "",
    "no-back": "",
    "no-action": ""
  }, {
    title: _withCtx(() => [
      _createTextVNode("Upload my tree")
    ]),
    secondaryAction: _withCtx(() => [
      _createElementVNode("button", {
        type: "button",
        class: "btn btn-outline-primary",
        onClick: _cache[0] || (_cache[0] = ($event: any) => (_unref(router).back()))
      }, " Back ")
    ]),
    default: _withCtx(() => [
      _hoisted_1,
      _createVNode(SyncAppTile),
      _createElementVNode("p", _hoisted_2, [
        _createVNode(_component_router_link, { to: { name: 'sync' } }, {
          default: _withCtx(() => [
            _createTextVNode("Learn more about the Sync app")
          ]),
          _: 1
        })
      ])
    ]),
    _: 1
  }))
}
}

})